export const commonCss={
    green:"rgb(0, 86, 151)",
    darkBlue:"rgb(0, 74, 131)",
    red:"rgb(0, 86, 151)",
    shadeGreen:"white",
    shadeRed:"white",
    darkgreen:"rgb(34, 139, 34)",
    darkred:"rgb(220, 53, 69)",
    yellow:"#ffbe0b",
    shadeLinearGradient:"white",
    normalLinearGradient:"linear-gradient(to right, rgb(0, 86, 151), rgb(0, 86, 151))",
    inputBorderRadius:"13px",
    inputBorderColor:"#747373",
    labelPadding:0.5,
    labelFontWeight:"500",
    labelInputColor:"black",
    inputBackgroundColor:"white",
    buttonBorderRadius:"13px",
    buttonTextColor:"white",
    mainLabelHeading:"bold",
    normalSentenceWeight:"bold",
    normalSenternceColor:"black",
    outSideSentenceColor:"white",
    paperBorderRadius:"10px",
    titleFontSize:"1.5rem",
    titleFontWeight:600,
    titleColor:"rgb(0, 86, 151)",
    readOnlyBGColor:"rgba(0, 0, 0, 0.05)",
    backgroundColor:"rgb(240, 235, 248)"
}

// #2362B4